import { Grid, Typography } from '@mui/material';
import { Control } from 'react-hook-form';
import { ResponsibilitiesForm } from './ResponsibilitiesForm';

interface ResponsibilitiesProps{
    control: Control<any>
}
export const Responsibilities = ({ control }: ResponsibilitiesProps) => {
    /* ******************** Hooks ******************** */
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <Grid container gap={'20px'} display={"flex"} flexDirection={"column"}>
            <Typography variant='lora-title-large' color={'primary'} fontWeight={'bold'}>Provide job responsibilities</Typography> 
            <ResponsibilitiesForm control={control} />
        </Grid>
    )
}